import {CardConfiguration} from './card-configuration';
import {TranslateHandlebarsPipe} from '../../../../../shared/pipes/translate-handlebars.pipe';
import {LinkActions} from '../../common/base-card-configuration';
import {CertificateService} from '../../../content/certificate/certificate.service';

declare var moment: any;

export class MettlExamCardConfiguration extends CardConfiguration {
  constructor(course: any, certificateService: CertificateService, translateHandlebarsPipe: TranslateHandlebarsPipe) {
    super();
    // let hoursSinceRelease = moment.duration(moment().diff(moment(course.releaseDate, 'YYYY.MM.DD HH:mm').toDate())).asHours();
    // console.log(course);
    this.tagType = 'mettlExam';
    // this.classType = (hoursSinceRelease <= 72 && !course.expired) ? 'New Exam' : 'Exam';
    this.classType = 'Exam';
    this.thumbnail = course.smallImageUri || 'https://itpx-branded-portal-dev.s3.amazonaws.com/courseware.png';
    this.expired = course.expired;
    this.clickable = false;
    this.links = [];
    this.target = ['course', course.id];
    this.action = LinkActions.REDIRECT;
    this.links.push({
      disabled: this.expired,
      tooltip: this.expired ? 'branded.portal.courses.assignment.material.tooltip' : null,
      url: this.expired ? [] : this.target,
      type: LinkActions.REDIRECT,
      text: 'branded.portal.courses.assignment.material.text'
    })
    if (course.productVariant
      && course.productVariant.deliveryFormat) {
      // requires refactoring of Solar BE to pre-render the content
      // if ('ebook' === course.productVariant.deliveryFormat.toLowerCase()) {
      //     this.links.push({
      //         disabled: this.expired,
      //         tooltip: this.expired ? 'branded.portal.courses.assignment.ebook.download.tooltip' : null,
      //         url: this.expired ? [] : [],
      //         text: 'branded.portal.courses.assignment.ebook.download.text',
      //         download: true,
      //         image: this.expired ? 'https://itpx-branded-portal-dev.s3.amazonaws.com/download-inactive.svg' :
      //             'https://itpx-branded-portal-dev.s3.amazonaws.com/download.svg'
      //     })
      // } else
      if ('elearning' === course.productVariant.deliveryFormat.toLowerCase()
        && course.elearningCertificate) {
        this.links.push({
          disabled: course.completionPercentage < 100,
          tooltip: course.completionPercentage < 100 ? 'branded.portal.courses.assignment.elearning.certificate.download.tooltip' : null,
          url: course.completionPercentage < 100 ? [] : [],
          text: 'branded.portal.courses.assignment.elearning.certificate.download.text',
          type: LinkActions.ACTION,
          action: (certificate) => certificateService.getElearningCertificates(certificate.id)
            .switchMap(res => certificateService.getElearningCertificateDownloadLink(res.data[0].id))
            .switchMap(res => certificateService.getCertificateFile(res.data.certLocation, translateHandlebarsPipe
              .transform('branded.portal.courses.assignment.elearning.certificate.filename', certificate))),
          download: true,
          image: course.completionPercentage === 100 ? 'https://itpx-branded-portal-dev.s3.amazonaws.com/download.svg' :
            'https://itpx-branded-portal-dev.s3.amazonaws.com/download-inactive.svg'
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/course/configurations/mettl-exam-card-configuration.ts